import axios from "axios";

const ENDPOINT_KEY = "file";
const ENDPOINT_URI = "/file";

export default function useFileService() {
  return {
    queryKey: ENDPOINT_KEY,
    uploadSingleFile: async (file) => {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(ENDPOINT_URI, formData);
      return response.data?.payload;
    },
    uploadMultipleFiles: async (files) => {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("files", file);
      });
      const response = await axios.post(ENDPOINT_URI, formData);
      return response.data?.payload;
    },
    getFileDetails: async (fileId) => {
      const response = await axios.get(`${ENDPOINT_URI}/${fileId}`);
      return response.data?.payload;
    },
    deleteFile: async (fileId) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${fileId}`);
      return response.data?.payload;
    },
  };
}
